import { render, staticRenderFns } from "./ProfessionalInfoNurse.vue?vue&type=template&id=bb12f89e"
import script from "./ProfessionalInfoNurse.vue?vue&type=script&lang=js"
export * from "./ProfessionalInfoNurse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports